import vClickOutside from "v-click-outside";
import { mapGetters } from "vuex";
import { dialogHelper } from "@/components/mixin/dialogHelper";
import userStatusHelper from "../../../../components/mixin/userStatusHelper";
import { sessionHelper } from "../../../../components/mixin/sessionHelper";
import { dashboardNavigation } from "@/components/mixin/dashboardNavigation";
import BrandApi from "@/services/api/brandApi";

const BrandAPiService = new BrandApi();

export default {
  mixins: [dialogHelper, userStatusHelper, sessionHelper, dashboardNavigation],
  directives: {
    clickOutside: vClickOutside.directive,
  },
  computed: {
    notificationCount() {
      return this.$store.getters.notificationState;
    },
    draftCount() {
      return this.$store.getters.draftCount;
    },
    ...mapGetters({
      user: "userState",
      draftCount: "draftCount",
    }),
    filteredLinks() {
      return this.links.filter((link) => link.excludeFromNav === undefined || link.excludeFromNav);
    },
    links() {
      return this.dashboardMenu;
    },
  },
  data() {
    return {
      isAsideVisible: true,
    };
  },

  beforeMount() {
    this.setActiveSidebarItem();
    this.toggleAssideMenu();
  },

  async mounted() {
    this.$eventBus.$on("toggle-dashboard-sidebar", this.toggleSidebarCallback);
    window.addEventListener("resize", this.toggleAssideMenu);
    this.$store.dispatch("getDraftCount");
    if (this.user.role === "BRAND") {
      const { data } = await BrandAPiService.getBrandMe();
      if (data.shopify) {
        this.links
          .find(({name}) => name === 'Products').children
          .find(({name})=> name === "Inventory")
          .disabled = true
        ;
      }
    }
  },

  beforeDestroy() {
    this.$eventBus.$off("toggle-dashboard-sidebar", this.toggleSidebarCallback);
    window.removeEventListener("resize", this.toggleAssideMenu);
  },

  methods: {
    setActiveSidebarItem,
    toggleSidebarItem,
    collapseSidebarItems,
    redirect,
    closeSidebar,
    toggleSidebarCallback,
    toggleAssideMenu,
    handleParentLinkClick,
    getMenuCount,
    navigateToChild,
    preventNavigationBasedOnState,
  },
};

function redirect(path) {
  this.collapseSidebarItems();
  this.toggleAssideMenu();

  this.$router.push(path);
}

function toggleSidebarItem(targetIndex) {
  this.links.forEach((item, index) => {
    if (index !== targetIndex) {
      item.isExpanded = false;
    }
  });

  this.$set(this.links[targetIndex], "isExpanded", !this.links[targetIndex].isExpanded);
}

function handleParentLinkClick(link, index) {
  this.$store.dispatch("navigation/hideSideBar");
  const routePrefix = link.linkOut ? "" : "/dashboard/";
  if (link.isExpanded === false && link.children) {
    this.toggleSidebarItem(index);
    this.$router.push(routePrefix + link.children[0].path);
  } else {
    if (link.children) {
      this.toggleSidebarItem(index);
    } else if (!this.preventNavigationBasedOnState(link)) {
      this.redirect(routePrefix + link.path);
    }
  }
}

function navigateToChild(menuItem) {
  if (!menuItem.path) {
    return;
  }
  this.$store.dispatch("navigation/hideSideBar");
  this.$router.push("/dashboard/" + menuItem.path);
  this.toggleAssideMenu();
}

function collapseSidebarItems() {
  this.links.forEach((item) => {
    item.isExpanded = false;
  });
}

function setActiveSidebarItem() {
  this.links.forEach((link) => {
    // if link doesn't contain children
    if (!link.children && link.supportedRoutes && link.supportedRoutes.includes(this.$route.name)) {
      link.isExpanded = true;
    }

    if (link.children) {
      link.children.forEach((child) => {
        if (child.supportedRoutes.includes(this.$route.name)) {
          link.isExpanded = true;
        }
      });
    }
  });
}

function toggleSidebarCallback() {
  this.isAsideVisible = !this.isAsideVisible;
}

function closeSidebar() {
  this.isAsideVisible = false;
}

function toggleAssideMenu() {
  let width = document.documentElement.clientWidth;
  this.isAsideVisible = width >= 993;
}

// function hasMenuAccess(link) {
//   return this.user && link.access.indexOf(this.user.role) !== -1;
// }

function preventNavigationBasedOnState(menuItem) {
  if (!menuItem.checkUserState) {
    return false;
  }
  if (menuItem.path === "messages" && this.user.role === "BRAND") {
    return false;
  }
  if (menuItem.path === "messages" && !this.canSendMessage) {
    this.showMessageWarningToSuspendedOrDeclinedRetailers();
    return true;
  }
}

function getMenuCount(menuKey) {
  if (menuKey === "for-review") {
    return this.draftCount;
  }
}
